import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AccountService } from '@app/_services';
import { User } from '@app/_models';

@Component({
  selector: 'app-finance-dashboard',
  templateUrl: './finance-dashboard.component.html',
  styleUrls: ['./finance-dashboard.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class FinanceDashboardComponent implements OnInit {
  @Input() user: User;
  isLoading = true;
  
  // Dashboard metrics
  dashboardStats = {
    totalInvoices: 0,
    pendingInvoices: 0,
    completedInvoices: 0,
    totalRevenue: 0,
    monthlyRevenue: 0,
    recentInvoices: []
  };

  // Quick actions for finance users
  quickActions = [
    {
      title: 'Print Invoice',
      description: 'Print certificates and invoices',
      icon: 'fa-print',
      route: '/reports/printCertificate',
      color: 'primary'
    },
    {
      title: 'Invoice Report',
      description: 'View comprehensive invoice reports',
      icon: 'fa-file-text',
      route: '/reports/certificateReport',
      color: 'success'
    }
  ];

  constructor(private accountService: AccountService) {}

  ngOnInit(): void {
    if (!this.user) {
      this.user = this.accountService.userValue;
    }
    this.loadDashboardData();
  }

  private loadDashboardData(): void {
    // Simulate loading data
    setTimeout(() => {
      this.dashboardStats = {
        totalInvoices: 1247,
        pendingInvoices: 23,
        completedInvoices: 1224,
        totalRevenue: 2456780,
        monthlyRevenue: 345670,
        recentInvoices: [
          { id: 'INV-001', dealer: 'ABC Motors', amount: 15000, status: 'Completed', date: new Date() },
          { id: 'INV-002', dealer: 'XYZ Auto', amount: 22500, status: 'Pending', date: new Date() },
          { id: 'INV-003', dealer: 'PQR Dealers', amount: 18750, status: 'Completed', date: new Date() }
        ]
      };
      this.isLoading = false;
    }, 1000);
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'completed':
        return 'badge bg-success';
      case 'pending':
        return 'badge bg-warning';
      case 'cancelled':
        return 'badge bg-danger';
      default:
        return 'badge bg-secondary';
    }
  }
}
